<template>
  <div id="esnekcuzdan">
    <div class="authContainer">
      <img src="@/assets/images/esnekcuzdan.png" alt height="29" style="margin-bottom: 2rem"/>
      <form>
        <h4>Parola Sıfırlama</h4>
        <hr>
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
                  <span class="input-group-text">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
                          <g transform="translate(0)">
                              <path d="M23.983,101.792a1.3,1.3,0,0,0-1.229-1.347h0l-21.525.032a1.169,1.169,0,0,0-.869.4,1.41,1.41,0,0,0-.359.954L.017,115.1a1.408,1.408,0,0,0,.361.953,1.169,1.169,0,0,0,.868.394h0l21.525-.032A1.3,1.3,0,0,0,24,115.062Zm-2.58,0L12,108.967,2.58,101.824Zm-5.427,8.525,5.577,4.745-19.124.029,5.611-4.774a.719.719,0,0,0,.109-.946.579.579,0,0,0-.862-.12L1.245,114.4,1.23,102.44l10.422,7.9a.57.57,0,0,0,.7,0l10.4-7.934.016,11.986-6.04-5.139a.579.579,0,0,0-.862.12A.719.719,0,0,0,15.977,110.321Z" transform="translate(0 -100.445)"></path>
                          </g>
                      </svg>
                  </span>
            </div>

            <input autocomplete="off" class="form-control text-box single-line" data-val="true" data-val-length="Telefon numarası başında '0' olmadan 10 haneli şekilde girin." data-val-length-max="10" data-val-length-min="10" data-val-regex="Telefon formatı hatalı" data-val-regex-pattern="^(5(\d{9}))$" data-val-required="Bu alan boş bırakılamaz." id="Telephone" name="Telephone" placeholder="Telefon *" type="tel" value="">
            <span class="field-validation-valid text-danger" data-valmsg-for="Telephone" data-valmsg-replace="true"></span>

          </div>
        </div>
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
                      <g transform="translate(0)">
                          <path d="M23.983,101.792a1.3,1.3,0,0,0-1.229-1.347h0l-21.525.032a1.169,1.169,0,0,0-.869.4,1.41,1.41,0,0,0-.359.954L.017,115.1a1.408,1.408,0,0,0,.361.953,1.169,1.169,0,0,0,.868.394h0l21.525-.032A1.3,1.3,0,0,0,24,115.062Zm-2.58,0L12,108.967,2.58,101.824Zm-5.427,8.525,5.577,4.745-19.124.029,5.611-4.774a.719.719,0,0,0,.109-.946.579.579,0,0,0-.862-.12L1.245,114.4,1.23,102.44l10.422,7.9a.57.57,0,0,0,.7,0l10.4-7.934.016,11.986-6.04-5.139a.579.579,0,0,0-.862.12A.719.719,0,0,0,15.977,110.321Z" transform="translate(0 -100.445)"></path>
                      </g>
                  </svg>
              </span>
            </div>
            <input autocomplete="off" class="form-control text-box single-line" data-val="true" data-val-regex="E-Posta format hatası" data-val-regex-pattern="^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$" data-val-required="Bu alan boş bırakılamaz." id="Email" name="Email" placeholder="E-Posta *" type="text" value="">
            <span class="field-validation-valid text-danger" data-valmsg-for="Email" data-valmsg-replace="true"></span>
          </div>
        </div>
        <div>
          <b-button type="submit" variant="primary" block>Sıfırla</b-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
